import React from 'react';
import { Typography } from '@mui/material';
import { colors, fonts, spacing } from '../../../constants';

/**
 * FieldValue Component
 * Reusable field value display for query modal
 * 
 * @param {string} value - Value to display
 */
const FieldValue = ({ value }) => {
  return (
    <Typography
      variant="body2"
      sx={{
        fontSize: fonts.fontSizeMd,
        color: colors.textPrimaryDark,
        fontWeight: fonts.weightMedium,
        mb: spacing.xs,
      }}
    >
      {value || 'N/A'}
    </Typography>
  );
};

export default FieldValue;
